import { render, staticRenderFns } from "./QuestionAttachments.vue?vue&type=template&id=81b65f16&scoped=true"
import script from "./QuestionAttachments.vue?vue&type=script&lang=js"
export * from "./QuestionAttachments.vue?vue&type=script&lang=js"
import style0 from "./QuestionAttachments.vue?vue&type=style&index=0&id=81b65f16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b65f16",
  null
  
)

export default component.exports